import React, { useState, useEffect } from 'react';
import { manageDisableScrolling } from '../../ducks/UI.duck';

import { compose } from 'redux';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Modal } from '..';

/**
 * Renders a modal into the app's global portal root.
 *
 * The component attaches the modal to the #portal-root element and
 * forwards the standard modal props to the shared Modal wrapper.
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.children]
 * @param {React.ReactNode} [props.slot]
 * @param {boolean} props.isOpen
 * @param {Function} props.onClose
 * @param {string} [props.id]
 * @param {string} [props.containerClassName]
 * @param {string} [props.contentClassName]
 * @param {boolean} [props.containerClassNameJoined]
 * @param {boolean} [props.isSticky]
 * @returns {React.ReactPortal|null}
 */
const ModalPortal = props => {
    const { children, slot = null, ...rest } = props;
    const [portalRoot, setPortalRoot] = useState(null);

    useEffect(() => {
        setPortalRoot(document.getElementById('portal-root'));
    }, []);

    const modalComponent = slot ? (
        <>
            {slot}
            <Modal {...rest}>{children}</Modal>
        </>
    ) : (
        <Modal {...rest}>{children}</Modal>
    );

    const modal = () => {
        return ReactDOM.createPortal(modalComponent, portalRoot);
    };

    return portalRoot ? modal() : null;
};

const mapDispatchToProps = dispatch => ({
    onManageDisableScrolling: (componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

export default compose(connect(null, mapDispatchToProps))(ModalPortal);
